import { render, staticRenderFns } from "./AcessarAtaItensBtnMaisAcoes.vue?vue&type=template&id=7c527677"
import script from "./AcessarAtaItensBtnMaisAcoes.vue?vue&type=script&lang=js"
export * from "./AcessarAtaItensBtnMaisAcoes.vue?vue&type=script&lang=js"
import style0 from "./AcessarAtaItensBtnMaisAcoes.vue?vue&type=style&index=0&id=7c527677&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports